import React from "react";
import PropTypes from "prop-types";
import { Navigate, useNavigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import {
  Box,
  Grid,
  Toolbar,
  Paper,
  Typography,
  AppBar,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  theme,
  StyledSearch,
  StyledSearchIconWrapper,
  StyledInputBase,
  StyledButtonReload,
  StyledButton,
  StylePaperLoad,
} from "./Styled-MisFacturas";
import Cookies from "js-cookie";
import { Header, MenuLateral } from "../Header/Header";
import { addFactura } from "../Data/MisFacturas-Data";
import { UpdateAccessToken } from "../Router/Cookies";
import MisFacturasTabla from "./MisFacturasTabla";
import CircularProgress from "@mui/material/CircularProgress";

function MisFacturas(props) {
  const navigate = useNavigate();
  const [filtro, setFiltro] = React.useState("");
  const [cargar, setCargar] = React.useState(true);
  const { misFacturas, setMisFacturas } = props;
  const usuario = Cookies.get("usuario");
  const operador = Cookies.get("operador");
  const access = Cookies.get("access");
  const id = Cookies.get("id");
  let IsSession = !!Cookies.get("access");

  React.useEffect(() => {
    fetchData(setMisFacturas);
    if (!UpdateAccessToken()) {
      return <Navigate to="/" />;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!UpdateAccessToken()) {
    return <Navigate to="/" />;
  }

  const fetchData = async (setPedidos) => {
    setMisFacturas([]);
    setCargar(true);

    const Values = {
      usuario: id,
      operador: operador,
    };
    const Peticion = new Request("api/facturas/getFacturas", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-access-token": access,
      },
      method: "POST",
      body: JSON.stringify(Values),
    });

    let DatosArray = [];
    try {
      const response = await fetch(Peticion);
      const data = await response.json();
      const Datos = data.data;

      Datos.map((item) =>
        DatosArray.push(
          addFactura(
            item.Fila,
            item.IdFactura,
            item.NomSociedad,
            item.CardName,
            item.FolioFactura,
            item.RFC,
            item.RFCReceptor,
            item.CPEmisor,
            item.CPReceptor,
            item.UUID,
            item.Entrada,
            item.FechaFactura,
            item.Total,
            item.FormaPago,
            item.TentativaPago,
            item.UsoPrincipal,
            item.MetodoPago,
            item.PDF ? item.PDF : "",
            item.XML ? item.XML : "",
            item.Recepcion ? item.Recepcion : "",

            item.CANCELED === "Y"
              ? "Cancelado"
              : item.EstatusFactura === "A"
              ? "Aceptada"
              : item.EstatusFactura === "R"
              ? "Rechazada"
              : "Pendiente",
            item.MetodoPago === "PUE"
              ? "Pagada"
              : item.CANCELED === "Y"
              ? "Pendiente"
              : parseFloat(item.PaidToDate ?? 0) < parseFloat(item.Total)
              ? "Pendiente"
              : "Pagada",
            item.FechaPago,
            item.Comentarios,
            item.BD,
            item.DocCur ? item.DocCur : "",
            item.Regimen
          )
        )
      );

      setPedidos(DatosArray);
    } catch (error) {
      console.error(error);
    }
    setCargar(false);
  };

  const handleForma = (event) => {
    event.preventDefault();
    fetchData(setMisFacturas);
  };

  const OnButtonClick = (event) => {
    if (event.target.id === "btnCrear") {
      navigate("/MisFacturas/Factura/Nuevo");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Header
          IsSession={IsSession}
          open={props.open}
          setOpen={props.setOpen}
          operador={operador}
          usuario={usuario}
        />
        <MenuLateral
          IsSession={IsSession}
          open={props.open}
          setOpen={props.setOpen}
        />
        <Box
          sx={{
            flexGrow: 10,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Toolbar />

          <Typography
            color="text.secondary"
            align="center"
            variant="h4"
            component="h4"
            margin={2}
          >
            Facturas
          </Typography>
          <Paper sx={{ maxWidth: "90%", margin: "auto", overflow: "hidden" }}>
            <AppBar
              position="static"
              sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}
            >
              <Toolbar>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs>
                    <StyledSearch>
                      <StyledSearchIconWrapper>
                        <SearchIcon />
                      </StyledSearchIconWrapper>
                      <StyledInputBase
                        placeholder="Search…"
                        inputProps={{ "aria-label": "search" }}
                        value={filtro}
                        onChange={(e) => setFiltro(e.target.value)}
                      />
                    </StyledSearch>
                  </Grid>
                  <Grid item xs align="right">
                    {operador === "Proveedor" && (
                      <StyledButton id="btnCrear" onClick={OnButtonClick}>
                        Agregar
                      </StyledButton>
                    )}

                    <Tooltip title="Recargar">
                      <StyledButtonReload
                        color="inherit"
                        onClick={handleForma}
                        size="medium"
                      >
                        <RefreshIcon
                          id="btnRefreshEmpleado"
                          color="inherit"
                          sx={{ display: "block" }}
                        />
                      </StyledButtonReload>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Toolbar>
              {
                <MisFacturasTabla
                  filtro={filtro}
                  rows={misFacturas}
                  operador={operador}
                />
              }
              <StylePaperLoad>
                {cargar === true && <CircularProgress />}
              </StylePaperLoad>
            </AppBar>
          </Paper>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

MisFacturas.propTypes = {
  misFacturas: PropTypes.array,
};

export default MisFacturas;
